// Czy ekran jest „wąski” (karuzela + arkusz dolny zamiast siatki) — rozstrzygnięcie 4a:
// „Wszystkie utwory (N)” na 1440 rozwija siatkę w miejscu, na 390 otwiera arkusz.
// Próg = ten sam, przy którym `.tiles` z ds.css staje się karuzelą (720 px).

import { useEffect, useState } from 'react'

export const NARROW_QUERY = '(max-width: 720px)'

export function useNarrow(query: string = NARROW_QUERY): boolean {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(query)
    const onChange = () => setNarrow(mq.matches)
    onChange()
    mq.addEventListener?.('change', onChange)
    return () => mq.removeEventListener?.('change', onChange)
  }, [query])
  return narrow
}
